module.exports = __webpack_public_path__ + "img/bg_1.bf320e3d.png";